import React, { useEffect, useState } from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Pillars from "@/components/landing/Pillars";
import SplitPanels from "@/components/landing/SplitPanels";
import WhoCanJoin from "@/components/landing/WhoCanJoin";
import Businesses from "@/components/landing/Businesses";
import HowItWorks from "@/components/landing/HowItWorks";
import TrustedCommunity from "@/components/landing/TrustedCommunity";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import JoinDialog from "@/components/landing/JoinDialog";

export default function Landing() {
  const [joinOpen, setJoinOpen] = useState(false);

  useEffect(() => {
    document.title = "Yuukke Business Exchange — Discover Women-Led Businesses";
  }, []);

  const openJoin = () => setJoinOpen(true);
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-brand-cream text-brand-ink">
      <Header onJoin={openJoin} onNav={scrollTo} />
      <main data-testid="landing-main">
        <Hero onJoin={openJoin} onExplore={() => scrollTo("businesses")} />
        <Pillars />
        <SplitPanels onJoin={openJoin} onExplore={() => scrollTo("businesses")} />
        <WhoCanJoin />
        <Businesses onJoin={openJoin} />
        <HowItWorks />
        <TrustedCommunity />
        <FinalCTA onJoin={openJoin} onExplore={() => scrollTo("businesses")} />
      </main>
      <Footer onNav={scrollTo} />
      <JoinDialog open={joinOpen} onOpenChange={setJoinOpen} />
    </div>
  );
}
